module.exports = __webpack_public_path__ + "media/images/icons/comment-plus-ccf6b80291c95c6e966c4229557183de.svg";